import { createBrandModelPair } from '../../utils/brandModelPair';
import { GlobalContextAction } from './GlobalContextActions';
import { GlobalActionType, GlobalStore } from './GlobalContextTypes';

const globalReducer = (
  state: GlobalStore,
  action: GlobalContextAction
): GlobalStore => {
  switch (action.type) {
    case GlobalActionType.UpdateFlowStep: {
      return {
        ...state,
        flowStep: action.payload.flowStep,
      };
    }
    case GlobalActionType.UpdateAmazonId: {
      // do not reset to empty if it's already populated
      if (
        state.amazonId === action.payload.amazonId ||
        !action.payload.amazonId
      ) {
        return state;
      }
      return {
        ...state,
        amazonId: action.payload.amazonId,
      };
    }
    case GlobalActionType.UpdateGetNotified: {
      const deviceKey = createBrandModelPair(
        action.payload.getNotified.brand,
        action.payload.getNotified.model
      );
      if (state.getNotified.has(deviceKey)) {
        return state;
      }
      const newGetNotified = new Set<string>(state.getNotified);
      newGetNotified.add(deviceKey);
      return {
        ...state,
        getNotified: newGetNotified,
      };
    }
    default:
      return state;
  }
};

export default globalReducer;
